<template>
  <div class="wg-row" style="padding:20px;">
    <div style="font-size:24px;">
      {{ $anm22.strLang(lang, 'Help center', 'Centro assistenza') }}
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="com-anm22-app-text-xxl">
      {{ $anm22.strLang(lang, 'Preferential call center', 'Assistenza telefonica preferenziale') }}
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <a :href="'tel:' + phoneLines[phoneLine].link">
      <div class="display-flex" style="flex-wrap:nowrap;align-items:center;">
        <img :src="$anm22.icons.getWorldIcon('phone')" class="com-anm22-app-img-fixed-height-m">
        <div class="com-anm22-app-text-xl" style="margin-left:10px;">
          {{ phoneLines[phoneLine].label }}
        </div>
      </div>
    </a>
    <div class="vertical-height-div" style="height:20px;"></div>
    <template v-if="phoneLine !== 0">
      <div class="com-anm22-app-text-xxl">
        {{ $anm22.strLang(lang, 'Call center', 'Assistenza telefonica') }}
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <a :href="'tel:' + phoneLines[0].link">
        <div class="display-flex" style="flex-wrap:nowrap;align-items:center;">
          <img :src="$anm22.icons.getWorldIcon('phone')" class="com-anm22-app-img-fixed-height-m">
          <div class="com-anm22-app-text-xl" style="margin-left:10px;">
            {{ phoneLines[0].label }}
          </div>
        </div>
      </a>
      <div class="vertical-height-div" style="height:20px;"></div>
    </template>
    <div class="com-anm22-app-text-xxl">
      {{ $anm22.strLang(lang, 'E-mail', 'Assistenza e-mail') }}
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <a href="mailto:support@spiagge.it">
      <div class="display-flex" style="flex-wrap:nowrap;align-items:center;">
        <img :src="$anm22.icons.getWorldIcon('email')" class="com-anm22-app-img-fixed-height-m">
        <div class="com-anm22-app-text-xl" style="margin-left:10px;">
          support@spiagge.it
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      phoneLine: 0,
      phoneLines: [
        {
          link: '+390541772375',
          label: '+39 0541 772375'
        },
        {
          link: '+393389880403',
          label: '+39 338 9880403'
        },
        {
          link: '+393386584075',
          label: '+39 338 6584075'
        },
      ]
    }
  },
  components: {
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
  },
  methods: {
    
  },
  created() {
    this.$Progress.finish();
  }
}
</script>

<style lang="scss" scoped>
</style>
